export default __webpack_public_path__ + "static/media/danger-icon.f240db25.svg";